import { Button, Popover } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import Style from './style.module.less'

@inject('store')
@observer
class Footer extends Component {
  publicHandler() {
    this.props.handleSubmit('save')
  }

  confirm() {
    this.props.store.deleteCase(
      this.props.isDraft ? this.props.draftId : this.props.id,
      this.props.isDraft
    )
  }

  saveDraft = () => {
    this.props.handleSubmit('draft')
  }

  render() {
    const { id, isDraft, store } = this.props
    const { case_detail } = store
    const showDraftBtn = !id || isDraft

    let showDelBtn = true
    let delTip = '确定删除草稿箱中的该案例吗？'

    if (isDraft) {
      delTip = '确定删除草稿箱中的该案例吗？'
    } else if (case_detail.is_never_sold) {
      // 从未上架
      delTip = '确定删除该案例？'
    } else if (case_detail.is_sold_out) {
      // 已下架
      delTip = '该案例已下架，删除后若您再次发布，则需要重新审核，确定删除吗？'
    } else {
      // 已上架  TODO 从未上架
      delTip = '该案例已上架，删除后顾客将无法访问该案例，确定删除吗？'
    }

    if (!id && !isDraft) {
      showDelBtn = false
    }
    return (
      <div className={Style.footer}>
        <Button
          type="primary"
          onClick={() => this.publicHandler()}
          style={{ width: '120px', height: '40px' }}
        >
          发布作品
        </Button>
        {showDraftBtn && (
          <Button
            type="default"
            onClick={this.saveDraft}
            style={{ width: '120px', height: '40px', marginLeft: '8px' }}
          >
            存为草稿
          </Button>
        )}
        {showDelBtn && (
          <Popover
            placement="top"
            content={
              <div className={Style.popStyle}>
                <div className={Style.popTip}>{delTip}</div>
                <div className={Style.popFooter}>
                  <Button
                    type="primary"
                    className={Style.popBtn}
                    onClick={() => this.confirm()}
                  >
                    删除
                  </Button>
                </div>
              </div>
            }
          >
            <span className={Style.delCaseBtn}>删除作品</span>
          </Popover>
        )}
      </div>
    )
  }
}

export default Footer
